
import React from 'react';
import { format } from 'date-fns';
import { Calendar, Clock } from 'lucide-react';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Calendar as CalendarComponent } from '@/components/ui/calendar';

interface SchedulePickerProps {
  rideDate: Date | undefined;
  setRideDate: (date: Date | undefined) => void;
}

const SchedulePicker: React.FC<SchedulePickerProps> = ({ rideDate, setRideDate }) => {
  return (
    <div className="flex flex-col sm:flex-row gap-4 items-start mb-6">
      <div className="w-full sm:w-1/2">
        <Label htmlFor="date" className="text-sm text-muted-foreground mb-2 block">
          Select Date
        </Label>
        <Popover>
          <PopoverTrigger asChild>
            <Button
              id="date"
              variant="outline"
              className="w-full justify-start text-left font-normal"
            >
              <Calendar className="mr-2 h-4 w-4" />
              {rideDate ? format(rideDate, "PPP") : <span>Pick a date</span>}
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-auto p-0">
            <CalendarComponent
              mode="single"
              selected={rideDate}
              onSelect={setRideDate}
              initialFocus
            />
          </PopoverContent>
        </Popover>
      </div>
      
      <div className="w-full sm:w-1/2">
        <Label htmlFor="time" className="text-sm text-muted-foreground mb-2 block">
          Select Time
        </Label>
        <select 
          id="time"
          className="w-full h-10 px-3 py-2 bg-background border rounded-md"
        >
          {Array.from({ length: 24 }, (_, i) => i).map(hour => (
            <React.Fragment key={hour}>
              <option value={`${hour}:00`}>{`${hour % 12 || 12}:00 ${hour < 12 ? 'AM' : 'PM'}`}</option>
              <option value={`${hour}:30`}>{`${hour % 12 || 12}:30 ${hour < 12 ? 'AM' : 'PM'}`}</option>
            </React.Fragment>
          ))}
        </select>
      </div>
    </div>
  );
};

export default SchedulePicker;
